import Plot from 'react-plotly.js'

import { getAnalytics } from '../../../api/analytics'
import useApiCall from '../../../api/useApiCall'
import RequestStateHandler from '../../RequestStateHandler/RequestStateHandler'

import { getPlotlyColorScale, getPlotlyLayout } from '../../../utils/styles'
import styles from './analytics-content.module.scss'

interface IAnalyticsContentProps {
    params: URLSearchParams
}

function AnalyticsContent(props: IAnalyticsContentProps) {
    const { params } = props

    const [{ data: analyticsData, ...responseState }] = useApiCall(
        getAnalytics,
        undefined,
        params.toString()
    )

    if (responseState.loading || responseState.error || !analyticsData) {
        return <RequestStateHandler state={responseState} />
    }

    return (
        <>
            {Object.keys(analyticsData).map((key) => (
                <section className={styles.analyticsContent} key={key}>
                    <Plot
                        data={analyticsData[key].data.map((data) => {
                            data.colorscale = getPlotlyColorScale(data.type)
                            return data
                        })}
                        useResizeHandler
                        layout={{
                            ...analyticsData[key].layout,
                            ...getPlotlyLayout(
                                analyticsData[key].data[0].type || ''
                            ),
                        }}
                        className={styles.analyticsContent__chart}
                    />
                </section>
            ))}
        </>
    )
}

export default AnalyticsContent
